// Vendor
import * as React from 'react';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';

// Bernie
import { ClickTracker } from 'bernie-analytics';
import { Context } from 'bernie-context';
import { LocalizedText } from 'bernie-l10n';
import { RouteStore } from 'bernie-core';

import { CurrentHotelStore } from 'src/common/stores/current-hotel-store';

// UITK
import { UitkPrimaryButton } from 'uitk-react-button';

const ButtonTracked = ClickTracker(UitkPrimaryButton);

export interface ChooseDatesCTAProps {
  hotelPosition: string;
  routeStore?: RouteStore;
  currentHotel?: CurrentHotelStore;
  context?: Context;
  dialog?: boolean;
}

export interface ChooseDatesCTAState {
  initialized: boolean;
}

export interface ChooseDatesCTAButtonProps {
  hotelPosition: string;
  onClick?: () => void;
  mounted?: boolean;
}

@inject('currentHotel', 'context')
@observer
export class ChooseDatesCTA extends React.Component<ChooseDatesCTAProps, ChooseDatesCTAState> {
  constructor(props) {
    super(props);
    this.state = {
      initialized: false,
    };
  }

  public componentDidMount() {
    this.setState({
      initialized: true,
    });
  }

  @action
  private openDatepicker = () => {
    const { currentHotel, dialog } = this.props;

    if (dialog) {
      this.props.routeStore.goBack();
    }
    currentHotel.setOpenNewDatePicker(true);
  };

  public render() {
    const { initialized } = this.state;
    const { hotelPosition } = this.props;

    return (
      <div className="uitk-grid all-x-gutter-three all-grid-align-middle">
        <div className="uitk-cell all-cell-fill uitk-type-right">
          <ChooseDatesCTAButton hotelPosition={hotelPosition} onClick={this.openDatepicker} mounted={initialized} />
        </div>
      </div>
    );
  }
}

export const ChooseDatesCTAButton = ({ hotelPosition, onClick, mounted }: ChooseDatesCTAButtonProps) => (
  <ButtonTracked onClick={onClick} linkName="Go to select dates" rfrr={`ROOM[${hotelPosition}].CHOOSEDATE.CTA`} disabled={!mounted}>
    <LocalizedText message="hotels.infosite.roomInfo.ctaButton.label" />
  </ButtonTracked>
);
ChooseDatesCTAButton.displayName = 'ChooseDatesCTAButton';
